<!-- =========================================================================================
  File Name: DataListArchive.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="data-list-list-view" class="data-list-container">

   <vs-table ref="table"  :data="filteredStudentList" :max-items="itemsPerPage"  pagination
              search>
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ACTION - DROPDOWN -->
          <vs-button v-if="select>0" color="danger" @click="deleteAll()">Delete ({{selected.length}})</vs-button>
           <vs-button v-if="select>0" color="success" class="ml-5" @click="restoreAll()">Restore ({{selected.length}})</vs-button>
            <!-- <vs-dropdown v-if="select>0" vs-trigger-click class="dd-actions cursor-pointer ml-4 mr-4 mb-4">
            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">{{ $t('common.action') }} ({{selected.length}})</span>
       </div>
            <vs-dropdown-menu>
              <vs-dropdown-item>
                <span class="flex items-center" @click="selectAction('deletestudent')">
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>{{ $t('common.delete') }}</span>
                </span>
              </vs-dropdown-item>
               <vs-dropdown-item>
                <span class="flex items-center"  @click="selectAction('activestudent')">
                  <feather-icon icon="ToggleRightIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t('common.enable') }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span class="flex items-center" @click="selectAction('deactivestudent')">
                  <feather-icon icon="ToggleLeftIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t('common.disable') }} </span>
                </span>
              </vs-dropdown-item>
              </vs-dropdown-menu>
          </vs-dropdown> -->
        </div>
      </div>

      <template slot="thead" >

        <vs-checkbox v-model="headCheckbox" @input="CheckAll()"></vs-checkbox>
        <vs-th>
        <span  @click="sorting('name')">{{ $t('student.table.name') }}</span>
        <feather-icon v-if="order && namestate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sorting('name')" />
        <feather-icon v-if="!order && namestate" icon="ChevronUpIcon" svgClasses="h-4 w-4"  class="ml-1" @click="sorting('name')" />
        </vs-th>

        <!-- <vs-th>
        <span  @click="sorting('name')">{{ $t('student.table.name') }}</span>
        <feather-icon v-if="order && namestate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sorting('name')" />
        <feather-icon v-if="!order && namestate" icon="ChevronUpIcon" svgClasses="h-4 w-4"  class="ml-1" @click="sorting('name')" />
        </vs-th> -->
        <vs-th>{{ $t('student.table.users') }}</vs-th>
        <vs-th>{{ $t('student.table.program') }}</vs-th>
        <!-- <vs-th>
        <span  @click="sortingstatus('status')">{{ $t('student.table.status') }}</span>
        <feather-icon v-if="statusorder && state" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingstatus('status')" />
        <feather-icon v-if="!statusorder && state" icon="ChevronUpIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingstatus('status')" />
        </vs-th> -->
        <vs-th>{{ $t('student.table.cameras') }}</vs-th>
        <vs-th>{{ $t('student.table.action') }}</vs-th>
      </template>

        <template slot-scope="{data}" >

          <tbody >

            <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td><vs-checkbox  @input="SelectItem(tr.id)" v-model="selectedCheck[indextr]"></vs-checkbox></vs-td>
            <vs-td  >
           <img v-if="tr.image" :src="img_cdn+tr.image" class="rounded-full shadow-md studentdot mr-2"/>
           <p v-else class="bg-primary studentdot text-white mr-2" :data-letterstudent=tr.fname[0].toUpperCase()></p>
          <!-- <img  :src="`/storage/images/${tr.image}`" class="rounded-full shadow-md product-img" /> -->
              <!-- <img :src="tr.image"   class="rounded-full shadow-md product-img" /> -->
                <span v-if="lng=='dogs'" class="text-sm font-bold">{{tr.fname}}</span>
                <span v-else class="text-sm font-bold">{{tr.fname}} {{tr.middle_name}} {{tr.lname}}</span>

            </vs-td>

                <vs-td>
                <div v-for="item in tr.users" :key="item.id">
                   <router-link :to="{ path: '/'+ $t('route.user_profile.title') +'/'+ item.id}" class="text-inherit underline">
                 <vs-chip >{{item.fname}} {{item.lname}}</vs-chip>
                  </router-link>
                </div>
                <!-- <feather-icon class="text-primary text-center" style = "text-align:center;"  @click.stop="addNewCamUser(tr)" icon="UserPlusIcon" svgClasses="h-4 w-4"/>  -->


              <vs-row>
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
              <!-- <vs-button  class="text-center"   @click.stop="addNewCamUser(tr)" size="small" icon-pack="feather" icon="icon-user-plus"></vs-button> -->

              <!-- <vs-button size="small" class="text-center" style="width:10px;float:left"  @click.stop="addNewCamUser(tr)"> -->
                 <!-- <feather-icon class="text-primary text-center" style = "text-align:center;"  @click.stop="addNewCamUser(tr)" icon="UserPlusIcon" svgClasses="h-4 w-4"/>  -->
                 <!-- <vs-button  class="text-center" style = "text-align:center;"  @click.stop="addNewCamUser(tr)" size="small" icon-pack="feather" icon="icon-user-plus"></vs-button>  -->
                <!-- {{ $t('student.table.add_user') }} -->
                <!-- </vs-button> -->
                <!-- <vs-button radius color="danger" type="gradient" icon-pack="feather" icon="icon-user-plus"></vs-button> -->
              </vs-col>
               </vs-row>
              </vs-td>
              <!-- <vs-td>
                <router-link :to="{ path: '/'+ $t('route.student_profile.title') +'/'+ tr.id}" class="text-inherit " >
                <p v-if="lng=='dogs'" class="text-sm font-small">{{tr.fname}}</p>
                <p v-else class="text-sm font-small">{{tr.fname}} {{tr.middle_name}} {{tr.lname}}</p>
                </router-link>
              </vs-td> -->
              <vs-td>
                <vs-chip v-if="tr.program.color_code" class="product-order-status text-white" :style="{background: tr.program.color_code}">{{ tr.program.name | title }}</vs-chip>
                <vs-chip v-else class="product-order-status" >{{ tr.program.name | title }}</vs-chip>
              </vs-td>
              <!-- <vs-td>
                <vs-switch v-model="tr.status"></vs-switch>
              </vs-td> -->
              <vs-td>
              <vx-tooltip v-for="item in tr.cameras" :key="item.id" :text="item.name" position="top">
               <span    :style="{background: item.color_code}" class="w-4 h-4 round" style="float: left"></span>
                </vx-tooltip>
              </vs-td>
               <vs-td>
                   <vs-button size="small"  @click="restore(tr.id)" color="success">Restore</vs-button>
                   <vs-button size="small" @click="confirmdelete(tr.id)" color="danger" class="ml-1">Delete</vs-button>
               </vs-td>
              <!-- <vs-td class="whitespace-no-wrap">
                 <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer " >
                  <div >
                    <feather-icon svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" icon="MoreVerticalIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                  <vs-dropdown-item>
                  <span class="flex items-center">
                  <router-link :to="{ path: '/'+ $t('route.student_profile.title') +'/' + tr.id}" class="text-inherit " >
                 <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-2 "/>  <span> View </span>
                </router-link>
                </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item>
                <span class="flex items-center" @click="editData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span> {{ $t('common.edit') }} </span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="confirmDeleteRecord(tr)">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>{{ $t('common.delete') }}</span>
                </span>
                </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="settingData(tr)">
                  <feather-icon icon="SettingsIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('student.action.settting') }}</span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item>
                <span class="flex items-center" @click="addSchedule(tr)">
                  <feather-icon icon="CalendarIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('student.action.schedule') }}</span>
                </span>
                </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                </vs-td> -->
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
     <div class="demo-alignment">
      <div class="fill-row-loading">
        <div :class="{'activeLoading':activeLoading}"  :id="[`loading-sound`]" class="vs-con-loading__container loading-example">
        </div>
      </div>
  </div>

  </div>
</template>

<script>
import {
  ALL_CAMERAS,
  ALL_LOCATIONS,
  ALL_STUDENTS,
  CAMERAS_BY_MANAGER_LOCATION,
  ME_DATA,
  PLAY_CAMERA,
  REMOVE_STUDENT,
  SINGLE_USER,
  STUDENTS_BY_LOCATION,
  UPDATE_STUDENT_STATUS,
  UPDATE_USER_ACTIVITY,
  USER_EMAIL_CONFIRMED,
  GENERATE_QR,
  ALL_ARCHIVE_STUDENT,
  RESTORE_STUDENT,
  FORCE_DELETE_STUDENT,
   RESTORE_ALL_STUDENT,
  FORCE_DELETE_ALL_STUDENT
} from '@/graphql'

export default {
   props: {
    isarchiveActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {

  },
  data() {
    return {
      order:false,
      statusorder:true,
      state:false,
      namestate:false,
      IframeSrc:'',
      headCheckbox:'',
      selectedCheck:[],
      students: [],
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      activeLoading:false,
      meID: '',
      meRole: '',
      img_cdn: '',
      lng:'',
      types: [
      'sound',
    ],

      custom_search_filter:'Search By Location',
      custom_search_filter_camera:'Search By Camera',

    }
  },
   watch: {
    isarchiveActive (val) {
      this.resetData()
      this.getStudent();
    }
  },

  computed: {
      filteredStudentList: function () {
      var custom_search_filter_camera = this.custom_search_filter_camera
      var custom_search_filter = this.custom_search_filter
      return this.students.filter(function(student) {
        if (custom_search_filter_camera != 'Search By Camera' && custom_search_filter == 'Search By Location') {
          for (var i = 0; i < student.cameras.length; i++) {
            if (student.cameras[i].name == custom_search_filter_camera) {
              return true;
            }
          }
          return false
        }
        else if (custom_search_filter_camera != 'Search By Camera' && custom_search_filter != 'Search By Location') {
          for (var i = 0; i < student.cameras.length; i++) {
            if (student.cameras[i].name == custom_search_filter_camera && student.location.name == custom_search_filter) {
              return true;
            }
          }
          return false
        } else if (custom_search_filter_camera == 'Search By Camera' && custom_search_filter != 'Search By Location') {

          if (student.location.name == custom_search_filter) {
            return true;
          } else {
            return false;

          }
        }
        else if (custom_search_filter == 'Search By Location') {
         return true;
        }
        // if(custom_search_filter !== 'Search By Location'){
        //   return student.location.name.match(custom_search_filter);
        // }
        return true;
      });
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    },

    locln() {
      return this.locations.length
    },
    queriedStudents () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.students.length
    },
    select (){
        return this.selected.length
    },
  },
methods: {
  resetData(){
             this.headCheckbox=false
    for (let index = 0; index < this.selectedCheck.length; index++) {
        this.selectedCheck[index]=false;
    }
  },
  deleteAll(){
            if(this.selected.length>0){
              this.$emit('popActive',this.selected)
}
  },
    restoreAll(){
            if(this.selected.length>0){
            this.$apollo
              .mutate({
                mutation: RESTORE_ALL_STUDENT,
                variables: {
                  id: this.selected,
                }
              }).then(response => {
               this.getStudent()
                this.selected=[];
                this.headCheckbox=false
                 for (let index = 0; index < this.selectedCheck.length; index++) {
                     this.selectedCheck[index]=false;
                }
               if(response.data.restoreAllStudent.status=='Success'){
               this.StatusSuccess(response.data.restoreAllStudent.message,response.data.restoreAllStudent.color)
               this.$emit('getdata',true)
          }
            }).catch(error => {

            });
}
  },
  selectAction(action){
  this.action=action
  },
     StatusSuccess(status,color) {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text:   status,
        color:  color,
        position: 'top-right'
      })

    },
  restore(id){
     this.$apollo
      .mutate({
        mutation: RESTORE_STUDENT,
        variables: {
        id: id,
     },
      })
      .then(response => {
         this.getStudent()
         if(response.data.restoreStudent.status=='Success'){
            this.StatusSuccess(response.data.restoreStudent.message,response.data.restoreStudent.color)
            this.$emit('getdata',true)
          }
        }).catch(error => {
         console.log(error)
      });
  },
  confirmdelete(id){
     this.$emit('popActive',id)
  //  this.$apollo
  //     .mutate({
  //       mutation: FORCE_DELETE_STUDENT,
  //       variables: {
  //       id: id,
  //    },
  //     })
  //     .then(response => {
  //        this.getStudent()
  //        if(response.data.forceDeleteStudent.status=='Success'){
  //           this.StatusSuccess(response.data.forceDeleteStudent.message,response.data.forceDeleteStudent.color)
  //         }
  //       }).catch(error => {
  //        console.log(error)
  //     });
  },
  getStudent(){
    this.students=[]
      this.activeLoading = true
      this.$vs.loading({
        type:'sound',
      })
     this.$apollo
      .mutate({
        mutation: ALL_ARCHIVE_STUDENT,
      })
      .then(response => {
          this.students=response.data.ArchiveStudents
          this.activeLoading = false
          this.$vs.loading.close()
      })
  },

    sorting(name){
    this.namestate=true
    this.state=false
    var column=name
    this.statusorder=true
    var order=this.order
    if(column=='name' && order==true){
    this.order=!this.order
    this.students.sort(function(a, b) {
    var textA = a.fname.toUpperCase();
    var textB = b.fname.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
}
 if(column=='name' && order==false){
    this.order=!this.order
    this.students.sort(function(a, b) {
    var textA = a.fname.toUpperCase();
    var textB = b.fname.toUpperCase();
    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
});
}
  } ,
sortingstatus(name){
   this.state=true
   this.namestate=false
   var column=name
   this.order=true
   var statusorder=this.statusorder
  if(column=='status' && statusorder==true){
    this.statusorder=!this.statusorder
    this.students.sort(function(a, b) {
    var textA = a.status
    var textB = b.status
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
}
 if(column=='status' && statusorder==false){
   this.statusorder=!this.statusorder
    this.students.sort(function(a, b) {
    var textA = a.status
    var textB = b.status
    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
});
}
  } ,
  getdata(value){
     if(value){
       this.get()
     }
     },
  CheckAll(){
    var selected=[]
    if(this.headCheckbox){
    for (let index = 0; index < this.students.length; index++) {
                 this.selectedCheck[index]=true;
                 selected.push(this.students[index].id)
                 }
        this.selected=selected
    }
    else{
      for (let index = 0; index < this.students.length; index++) {
                 this.selectedCheck[index]=false;
                 }
        this.selected=[]
    }
  },
SelectItem(id){
    if(!this.headCheckbox){
    var status=false
    for (var i = 0; i < this.selected.length; i++) {
    if (this.selected[i] == id) {
       status=true
    }
  }
  if(status){
  this.selected.pop(id)
  }
  else{
      this.selected.push(id)
  }
}
else{
    const index = this.selected.indexOf(id);
   if (index > -1) {
     this.selected.splice(index, 1);
  }
  else{
     this.selected.push(id)
  }
}
},
  conditionMethod(role,id){
     if(role=="manager"){
      this.$apollo
      .mutate({
        mutation: STUDENTS_BY_LOCATION,
        variables: {
        id:id
     },
      })
        .then(response => {
          this.students=[]
          this.locations=response.data.studentsbyLocation.managerlocations
          for (let i = 0; i < response.data.studentsbyLocation.managerlocations.length; i++) {
            for (let j = 0; j < response.data.studentsbyLocation.managerlocations[i].students.length; j++) {
                  this.students.push(response.data.studentsbyLocation.managerlocations[i].students[j])
            }
          }
        this.activeLoading = false
        this.$vs.loading.close()
        this.order=!this.order
        this.sorting('name')
      }).catch(error => {
          console.log(error)
      });
      this.$apollo
      .mutate({
        mutation: CAMERAS_BY_MANAGER_LOCATION,
        variables: {
        id:id
     },
      })
      .then(response => {
        var cameras=[]
        var users=[]
         for (let i = 0; i < response.data.user.managerlocations.length; i++) {
            for (let j = 0; j < response.data.user.managerlocations[i].cameras.length; j++) {
                  cameras.push(response.data.user.managerlocations[i].cameras[j])
            }
          }
        this.cameras=cameras
      }).catch(error => {
          console.log(error)
      });

      }
      if(role=="user"){
      this.$apollo
      .mutate({
        mutation: SINGLE_USER,
      variables: {
        id:id
     },
      })
      .then(response => {
        this.students=response.data.user.students
        this.order=!this.order
        this.sorting('name')
        this.activeLoading = false
        this.$vs.loading.close()
      })
      }
    if(role=="admin" || role=="center"){
      this.$apollo
      .mutate({
        mutation: ALL_STUDENTS,
      })
      .then(response => {
          this.students=response.data.students
          this.order=!this.order
          this.sorting('name')
          this.activeLoading = false
          this.$vs.loading.close()
      })
     this.$apollo
      .mutate({
        mutation: ALL_LOCATIONS,
      })
      .then(response => {
        this.locations=response.data.locations

      })
    this.$apollo
      .mutate({
        mutation: ALL_CAMERAS,
      })
      .then(response => {
        this.cameras = response.data.cameras
      })
    }
  },
     get(){
     this.$apollo
      .mutate({
        mutation: ME_DATA,
      })
      .then(response => {
        this.conditionMethod(response.data.me.roles[0].name,response.data.me.id)
      }).catch(error => {
          console.log(error)
      });

  }
  },
    mounted () {
    this.isMounted = true
  },
  created () {
    this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
    this.lng=process.env.VUE_APP_I18N_LOCALE
    // this.get()
  },
}
</script>

<style lang="scss">
#data-list-list-view {
.user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {

      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
      .product-img {
                height: 50px;
                border-radius: 50%;
              }
  }
  [data-letterstudent]:before {
  content:attr(data-letterstudent);
  }
  .studentdot{
  display:inline-block;
  font-size:35px;
  width:50px;
  height:50px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:-10px;
  margin-bottom:5px;
  }
}
</style>
